import React from 'react';

interface ProjectSelectionHintProps {
  hasSelectedOrganization: boolean;
  hasProjects: boolean;
}

export const ProjectSelectionHint: React.FC<ProjectSelectionHintProps> = ({
  hasSelectedOrganization,
  hasProjects,
}) => {
  if (!hasSelectedOrganization && !hasProjects) {
    return (
      <p className="text-sm text-gray-600 mb-3">
        💡 No projects available. Select a company from the sidebar to see their projects.
      </p>
    );
  }

  if (!hasSelectedOrganization && hasProjects) {
    return (
      <p className="text-sm text-gray-600 mb-3">
        💡 Currently showing all projects from all companies. Select a company from the sidebar to filter projects.
      </p>
    );
  }

  if (hasSelectedOrganization && !hasProjects) {
    return (
      <p className="text-sm text-yellow-600 mb-3">
        ⚠️ This company has no projects assigned yet.
      </p>
    );
  }

  if (hasSelectedOrganization && hasProjects) {
    return (
      <p className="text-sm text-gray-600 mb-3">
        ✅ Company selected. You can now choose specific projects or keep all selected.
      </p>
    );
  }

  return null;
};